import { createSelector } from 'reselect'
import moment from "moment";
import _ from 'lodash';
import { TIME } from "../appContainer/_utils/constants";

// constant time state reference  look-ups
const devoteesSelector = state => state.firestore.data.devotees;
const devotionalGroupsSelector = state => state.firestore.data.devotionalGroups;
const eventsSelector = state => state.firestore.data.events;
const attendancesSelector = state => state.firestore.ordered.attendances;
const displayedWeekSelector = state => state.views.displayedWeek;
const selectedDevotionalGroupIdSelector = state => state.views.selectedDevotionalGroup;
const loggedInDevoteeIdSelector = state => state.views.loggedInDevoteeId;

const loggedInDevoteeSelector = state => {
  const id = loggedInDevoteeIdSelector(state);
  const devotees = devoteesSelector(state);
  return devotees[id];
};

const membersSelector = state => {
  const selectedDevotionalGroup = selectedDevotionalGroupIdSelector(state);
  const devotionalGroups = devotionalGroupsSelector(state);
  return _.get(devotionalGroups, [selectedDevotionalGroup, 'members'], []);
};

const eventsInWeekSelector = createSelector(
  eventsSelector,
  displayedWeekSelector,
  (events, displayedWeek) => {
    const today = moment(displayedWeek);
    return Object.values(events).filter(({ startingOn }) => {
      const different = moment(startingOn).diff(today, 'days');
      return different >= -TIME.DAYS_IN_WEEK && different < 0;
    });
  }
);

const membersEventAttendancesSelector = createSelector(
  membersSelector,
  eventsInWeekSelector,
  attendancesSelector,
  (members, eventsInWeek, attendances) => {
    if (!members || !eventsInWeek || !attendances) { return []; }
    if (!members.length || !eventsInWeek.length || !attendances.length) { return []; }
    const result = Object.values(attendances)
      .filter(attendance => eventsInWeek.find(event => event.id === attendance.event.id))
      .filter(attendance => members.find(member => member.devotee.id === attendance.attendee.id));
    return result;
  }
);

const devotionalGroupLeadersSelector = createSelector(
  devoteesSelector,
  devotees => {
    const groupLeaders = Object.values(devotees)
      .filter(devotee => _.get(devotee, 'roles.devotionalGroupLeader'));
    return _.orderBy(_.uniq(groupLeaders), 'first');
  }
);

const sortedDevotionalGroupsByGroupNameSelector = createSelector(
  devotionalGroupsSelector,
  devotionalGroups => _.orderBy(Object.values(devotionalGroups), 'groupName')
);

const selectedDevotionalGroupSelector = state => {
  const groups = devotionalGroupsSelector(state);
  const selectedGroupLeaderId = selectedDevotionalGroupIdSelector(state);
  return groups[selectedGroupLeaderId];
};

const devotionalGroupsForLeaderSelector = state => {
  const groups = devotionalGroupsSelector(state);
  const selectedDevotionalGroup = selectedDevotionalGroupSelector(state);
  return Object.values(groups).filter(group => {
    return group.leader.id === selectedDevotionalGroup.leader.id;
  })
};

export {
  devoteesSelector,
  devotionalGroupsSelector,
  eventsSelector,
  attendancesSelector,
  displayedWeekSelector,
  eventsInWeekSelector,
  membersSelector,
  membersEventAttendancesSelector,
  loggedInDevoteeIdSelector,
  devotionalGroupLeadersSelector,
  sortedDevotionalGroupsByGroupNameSelector,
  selectedDevotionalGroupSelector,
  selectedDevotionalGroupIdSelector,
  loggedInDevoteeSelector,
  devotionalGroupsForLeaderSelector,
};
